import { createContext, useContext } from "react";

import { EpisodeV4, MentionCard, MentionV4 } from "@/types/MentionCard";
import { PaginatedMentionCards } from "@/types/PaginatedMentionCards";
import { Search } from "@/types/Search";
import { Tag } from "@/types/Tag";

export type MentionCardsContextType = {
  meta:
    | (Pick<PaginatedMentionCards, "page_count" | "count"> & {
        llm_irrelevant_mentions_count?: number;
      })
    | null;
  loading: boolean;
  mentionCards: MentionCard[];
  shareMention: MentionCard | null;
  errors?: Error[];
  alert: Search | null;
  tag: Tag | undefined;
  updateMention: (mention: MentionV4) => void;
  deleteMentionCard: (episode_uuid: EpisodeV4["id"]) => void;
  setMentionCards: (mentionCards: MentionCard[]) => void;
  patchMentionCard: (
    mentionCard: Partial<MentionCard> & { id: string }
  ) => void;
  closeShare: () => void;
  share: (mention: MentionCard) => void;
  shareV4: (mention: MentionCard) => void;
  hideActions?: boolean;
  hideTags?: boolean;
  hideReach?: boolean;
  hidePrValue?: boolean;
  hideSentiment?: boolean;
};

const MentionCardsContext = createContext<MentionCardsContextType>({
  meta: null,
  loading: true,
  mentionCards: [],
  alert: null,
  tag: undefined,
  patchMentionCard: () => null,
  setMentionCards: () => null,
  deleteMentionCard: () => null,
  updateMention: () => null,
  closeShare: () => null,
  shareMention: null,
  share: () => null,
  shareV4: () => null,
  hideActions: false,
  hideTags: false,
  hideReach: false,
  hidePrValue: false,
  hideSentiment: false,
});

export default MentionCardsContext;

export const useMentionCards = () => useContext(MentionCardsContext);
